import ReactDOM from "react-dom";
import React from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

export default class InjectReactEditor {
  constructor(cmp) {
    return class {
      constructor() {
        return new ReactCellEditor(cmp);
      }

      getGui() {} //dummy for validation
    };
  }
}

class ReactCellEditor {
  constructor(cmp) {
    this.cmp = cmp;
  }

  init(params) {
    this.agGridProps = params;
    this.el = document.createElement("div");
  }

  getGui() {
    return this.el;
  }

  afterGuiAttached() {
    const CMP = this.cmp;

    if (this.isRendered) {
      return;
    }
    this.isRendered = true;

    ReactDOM.render(
      <DndProvider backend={HTML5Backend}>
        <CMP onChange={this.handleChange} {...this.agGridProps} />
      </DndProvider>,
      this.el
    );
  }

  getValue() {
    return (
      this.value ??
      this.cmp.prototype.getDefaultValue?.(this.agGridProps) ??
      this.agGridProps.value
    );
  }

  isPopup() {
    return this.cmp.prototype.isPopup?.() ?? false;
  }

  handleChange = (value) => {
    this.value = value;
  };

  destroy() {
    ReactDOM.unmountComponentAtNode(this.el);
  }
}
